var _rect, _rect2, _rect3, _rect4, _circle, _rect5, _path, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 100,
    fill: "#F0F3F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1075 -414)",
    fill: "#F5F6F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1011,
    y: -260,
    width: 1311,
    height: 804,
    rx: 8,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -72.5,
    y: -58.5,
    width: 246,
    height: 313,
    rx: 7.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#F5F7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -72.5,
    y: -58.5,
    width: 246,
    height: 313,
    rx: 7.5,
    stroke: "#A7AABD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.667 36.6666H61.0003C61.8844 36.6666 62.7322 37.0178 63.3573 37.6429C63.9825 38.268 64.3337 39.1159 64.3337 39.9999V63.3333C64.3337 64.2173 63.9825 65.0652 63.3573 65.6903C62.7322 66.3154 61.8844 66.6666 61.0003 66.6666H41.0003C40.1163 66.6666 39.2684 66.3154 38.6433 65.6903C38.0182 65.0652 37.667 64.2173 37.667 63.3333V39.9999C37.667 39.1159 38.0182 38.268 38.6433 37.6429C39.2684 37.0178 40.1163 36.6666 41.0003 36.6666H44.3337M46.0003 33.3333H56.0003C56.9208 33.3333 57.667 34.0794 57.667 34.9999V38.3333C57.667 39.2537 56.9208 39.9999 56.0003 39.9999H46.0003C45.0799 39.9999 44.3337 39.2537 44.3337 38.3333V34.9999C44.3337 34.0794 45.0799 33.3333 46.0003 33.3333Z",
    stroke: "#2B5297",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -21208,
    y: -33653,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicPlans);
export default __webpack_public_path__ + "static/media/topic-plans.576cb6e7b0e3d7702651144ff21203bd.svg";
export { ForwardRef as ReactComponent };